module.exports = __webpack_public_path__ + "61c53da62d9ed932332f76a6c5b5917e.jpg";